import React, { Component } from 'react'
import Blogcontent from './blogcontent'
import Image from 'next/image'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
export class Blog extends Component {
  render() {
    const {TrendingCourses}=this.props
    return (
      <>
       <section className="pdb50 mpdtb10">
                      <div className='container pdt30'>
                    <div className='df fjsb mdf mfdc mpdt0'>
                        <div className='layer1 pd10'>
                          <div className='mdn'>
                        <Image src={`${this.props.image}`} alt={this.props.alt} width={"800"} height={"450"} loading='lazy'/>
                        </div>
                        <div className='dn mdf mfjc'>
                        <Image src={`${this.props.image}`} alt={this.props.alt} width={"290"} height={"150"} loading='lazy'/>
                        </div>
                          <Blogcontent blog={this.props.blog} />
                        </div>
                        <div className='layer2 mpdt20 mdf mfdc mfac mfjc'>
                        {/* <div className='lay2'>
                            <Blogside recblog={this.props.recblog} recblogpath={this.props.recblogpath} recblog1={this.props.recblog1} recblogpath1={this.props.recblogpath1}
                            recblog2={this.props.recblog2} recblogpath2={this.props.recblogpath2} recblog3={this.props.recblog3} recblogpath3={this.props.recblogpath3} recblog4={this.props.recblog4} recblogpath4={this.props.recblogpath4}/>
                        </div> */}
                        <LearnSoftLogo/>
                        </div>
                    </div>
                </div>
            </section>
            <style jsx>
            {`
            .layer1{
                width:65%;
                background-color: #fff;
                border-radius:1px;
                box-shadow:  0px 0px 5px #888888;           
             }
             .layer2{
                width: 31%; 
                background-color: #fff;
             }
             .lay2{
              max-height:950px;
              box-shadow:  0px 0px 5px #888888;
             }
             @media only screen and (max-width: 1223px) {
              .layer1{
                width:100%;         
             }
             .layer2{
                width: 100%; 
             }
             }
            `}
          </style>
      </>
    )
  }
}

export default Blog